import { Text, css, styled, Box } from '@chilipiper/design-system'
import { markdownStyles } from '../../../helpers/markdown'

export const StyledTextContainer = styled(Box)<{ isOwnMessage: boolean }>`
  line-height: 1;
  ${({ theme, isOwnMessage }) =>
    isOwnMessage
      ? css`
          color: rgb(var(--primary-contrast-color));
          background-color: rgb(var(--primary-color));
        `
      : css`
          color: ${theme.colors['fg/major']};
          background: ${theme.colors['bg/section-emphasis']};
        `}
`

export const StyledText = styled(Text)`
  display: block;
  color: inherit;

  ${markdownStyles}
`
